import ModalComponent from "@/common/Modal";
import { OptInModalProps } from "../types";
import { Box, Button, Text, Switch, Divider } from "@chakra-ui/react";
import { useState, useEffect } from 'react'
import './OptInForm.scss';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { setDealerActionsToBeSaved, setIsCreateDealerActionInprogress, callToCreateDealerAction} from '@/explore/ducks/slice';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { getStoreId } from '@/redux/app-selectors';

import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callToGetDealerDetail } from "../ducks/slice";

export function UpdateDealerForm({ data }: { data: DealerProfileType }) {  
  const dispatch = useDispatch();

  const storeId = getStoreId()
  const {blacklistedStores} = data?.businessDetails;
  const [blackistedDealer,setBlackistedDealer] = useState<boolean>(blacklistedStores.includes(storeId) ? true : false)
  const [defaultStatusBlacklisted, setDefaultStatusBlacklisted] = useState(true);

  useEffect(()=>{
     dispatch(setDealerActionsToBeSaved([]))
  },[])
  
  useEffect(() => {
      dispatch(setDealerActionsToBeSaved([{
            name: 'blacklisted',
            type: 'create',
            value: blackistedDealer,
            license_key: data?.primaryInboundDetails?.licenseKey || '',
            dealer_id: data?._id,
        }]));
  },[blackistedDealer])
 
  const onChangeDealerPreference = (event:any,field:string) => {
    if (field === 'blacklisted') {
        if (event.target.checked) setBlackistedDealer(true);
        else setBlackistedDealer(false); 
    }
  }

  return (
    <Box>
      <Box className="update_preferences_text">
        <Text className="update_preferences_title">Update Dealer’s Status.</Text>
      </Box>
      <Box className="toggle_section_wrapper">
        <Box className="toggle_section">
          <Text>Blacklisted </Text>
          <Switch color={'#d6d6d6'} size='lg' onChange={(event: any) => {
            setDefaultStatusBlacklisted(false)
            onChangeDealerPreference( event,'blacklisted')
          }}
            isChecked={defaultStatusBlacklisted? (blacklistedStores.includes(storeId) ? true : false) : blackistedDealer }
            sx={{
              '& .chakra-switch__track': { bg: '#d6d6d6' }, // Track color when unchecked
              '& .chakra-switch__thumb': { bg: 'white.600', border: '2px', borderColor: '#d6d6d6.300' }, // Thumb color when unchecked
              '.chakra-switch__track[data-checked]:not([data-theme])': { backgroundColor: 'green.100', },
              '.chakra-switch__thumb[data-checked]:not([data-theme])': { backgroundColor: 'green.400', border: '2px', borderColor: 'green.100' },
            }}
          />
        </Box>
      </Box>
      <Divider style={{ width: '90%', margin: 'auto' }} />
    </Box>
  );
}

export default function BlacklistedModal({
  isOpen,
  onClose,
  data
}: OptInModalProps) {
  const dispatch = useDispatch()
  const params: any = useParams()
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted()
  const storeId = getStoreId();

  const defaultValue = dealerActionsToBeSaved.map((item:any) => item.value)[0]
  const {blacklistedStores } = data.businessDetails
  const value = blacklistedStores.includes(storeId)
  const onSaveHandler = async () => {
    dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved }));
  };

  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      dispatch(callToGetDealerDetail(params?.dealerId));
      onClose()
    }
  }, [isCreateDealerActionCompleted, isCreateDealerActionInprogress])

  return (
    <ModalComponent
      title="Blacklisted"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      className="btns"
      maxWidth="500px"
      footer={
        <Box className="opt-in-footer">
          <Button
            className="cancel_btn"
            onClick={() => {
              dispatch(setDealerActionsToBeSaved([]))  
              onClose();
            }}
            isDisabled={isCreateDealerActionInprogress}
          >
            Cancel
          </Button>
          <Button
            className="save_btn"
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveHandler}
            isLoading={isCreateDealerActionInprogress}
            isDisabled={value === defaultValue}
          >
            Save
          </Button>
        </Box>
      }

    >
      <UpdateDealerForm data={data} />

    </ModalComponent>
  )
}
